import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Business from "./Business";
import Testimonial from "./Testimonial";

export default function Transportation() {

    return (
        <>
            <div className="aboutus_bg" >
                <div className="aboutus-img-content">
                    <h1>Transportation</h1>
                </div>
            </div>

          
            <Container className="it-overview mt-5 mb-5">
                {/* <h6>OVERVIEW</h6> */}
                <h3 className="text-center" style={{ color: '#0e2b5c', paddingBottom: '15px' }}>Driving Efficiency in the Digital Age</h3>
                <div className="overview-container" style={{ padding: '0 12%', color: '#627792', fontSize: '18px', fontWeight: '500', lineHeight: '1.8' }}>
                    <p >From logistics to fleet management, the transportation industry demands precision and speed. Our digital solutions revolutionize route planning, optimize fuel efficiency, and ensure regulatory compliance. By integrating GPS tracking, AI-powered scheduling, and automated freight management, we enhance mobility solutions. We help businesses minimize costs, reduce environmental impact, and streamline the movement of goods and people.
                    </p>
                </div>
            </Container>
            {/**benefit */}

            <section className="py-5 text-light mb-5" style={{ backgroundColor: "#141b29" }}>
                {/* <h6 className="text-uppercase text-center text-info mb-2">Benefits to Transportation on</h6> */}
                <h2 className="text-center mb-5">Our Solutions for Transportation
                </h2>
                <Container>
                    <Row>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>AI-driven route optimization to minimize delays</h5>
                                <p>Our AI-powered route optimization technology analyzes real-time traffic data, weather conditions, and historical patterns to determine the most efficient routes. This not only reduces travel time and fuel costs but also enhances delivery reliability. By leveraging machine learning, businesses can proactively adjust routes to avoid congestion and improve service quality.</p>
                            </div>
                        </Col>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>Real-time tracking & fleet management for operational transparency</h5>
                                <p> With GPS-enabled fleet tracking and IoT-powered monitoring systems, businesses gain complete visibility over their transportation operations. Real-time tracking ensures better asset utilization, reduces vehicle downtime, and improves security. Live alerts and automated reports enhance operational control, leading to increased efficiency and customer satisfaction.</p>
                            </div>
                        </Col>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>Automated compliance monitoring to ensure safety & legal adherence</h5>
                                <p> Regulatory compliance is critical in the transportation industry, and our automated systems ensure strict adherence to safety and legal standards. From electronic logging of driver hours to AI-driven risk assessments, our solutions help companies avoid fines and penalties. By automating compliance reporting and documentation, businesses can focus on efficiency while maintaining high safety standards.
                                </p>
                            </div>
                        </Col>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>Smart Logistics & Freight Automation for Cost-Effective Operations</h5>
                                <p>Logistics automation streamlines warehouse management, order processing, and freight movement, reducing manual errors and operational costs. AI-powered demand forecasting helps optimize inventory levels, ensuring faster order fulfillment. With intelligent freight scheduling and automated dispatch, businesses can maximize efficiency while maintaining agility in supply chain operations.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>

            </section>

            <Business/>
        </>
    )
}